import gql from 'graphql-tag';

export const GET_THE_FLOW_INFO = gql`
  query getTheFlowInfo {
    self {
      id
      firstName
      lastName
      authId
      positionStatus
      oweStatus
      email
      profilePicture
      fullName
      referredBy {
        id
        doterraAccount {
          id
          memberId
        }
      }
      doterraAccount {
        id
        backOfficeLink
      }
      referralLinks {
        id
        link
        label
      }
    }
    labModules(sort: "priority") {
      id
      name
      coverImage {
        url
      }
    }
  }
`;
